<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[schedules$]"></ef-loading-container>
<ef-loading
    [processing]="showTimer"
    [processingText]="processingText"
    [loading]="recalculateContractsDataService.loading$ | async"
></ef-loading>
<ef-recalculate-transactions-presenter
    [contractsLoading]="contractsLoading$ | async"
    [process]="process$ | async"
    [schedules]="schedules$ | async"
    [contracts]="contracts$ | async"
    [initialContracts]="initialContracts$ | async"
    [clearSelectedSchedules$]="clearSelectedSchedules$.asObservable()"
    [settings]="settings$ | async"
    [userInfo]="userInfo$ | async"
    [qboEnabled]="isQBOEnabled$ | async"
    [hasValidTokens]="hasValidTokens$ | async"
    (Step1)="onStep1($event)"
    (Step2)="onStep2($event)"
    (Step3)="onStep3($event)"
    (GetContracts)="onGetContracts($event)"
    (GetSchedules)="onGetSchedules($event)"
    (GetSettings)="onGetSettings($event)"
    (ApplyInvoiceChanges)="onApplyInvoiceChanges($event)"
    (UpdateSettings)="onUpdateSettings($event)"
></ef-recalculate-transactions-presenter>
